import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CommonService } from 'src/@services/common.service';
import { clearLocalStoragePreserving } from 'src/@shared/auth/auth-state';

@Component({
    selector: 'app-site-under-maintenance',
    templateUrl: './site-under-maintenance.component.html',
    styleUrls: ['./site-under-maintenance.component.scss'],
    standalone: false
})
export class SiteUnderMaintenanceComponent implements OnInit {
  constructor(public location: Location, public _cS: CommonService) {}

  ngOnInit(): void {}
  clearStorange() {
    clearLocalStoragePreserving();
  }
}
